export class AppData {
    constructor(events) {
        this.catalog = [];
        this.events = events;
        this.order = this.setBaseOrder();
    }
    setCatalog(products) {
        this.catalog = products;
        this.events.emit('store:init', this.catalog);
    }
    setSelectedProduct(product) {
        this.selectedProduct = product;
        this.events.emit('product:open', this.selectedProduct);
    }
    setBaseOrder() {
        return {
            totalPrice: null,
            products: [],
            method: null,
            address: null,
            email: '',
            phone: '',
        };
    }
    addToCart(product) {
        this.order.products.push(product);
    }
    removeFromCart(product) {
        this.order.products = this.order.products.filter((item) => item.id !== product.id);
    }
    checkItemInCart(product) {
        return this.order.products.find((item) => item.id === product.id)
            ? true
            : false;
    }
    getTotalPrice() {
        return this.order.products.reduce((a, b) => a + b.price, 0);
    }
    setPaymentInfo(data) {
        this.order.method = data.method;
        this.order.address = data.address;
    }
    setUserInfo(data) {
        this.order.phone = data.phone;
        this.order.email = data.email;
    }
    sendOrder() {
        this.order.totalPrice = this.order.products.reduce((sum, item) => sum + item.price, 0);
        const completedOrder = {
            payment: this.order.method,
            email: this.order.email,
            phone: this.order.phone,
            address: this.order.address,
            total: this.order.totalPrice,
            items: this.order.products
                .filter((item) => item.price)
                .map((item) => item.id),
        };
        this.events.emit('order:send', completedOrder);
    }
}
